// Khối "Tư vấn cùng An Thư" trên Home — form 3 trường + popup chat guest (không cần đăng nhập).
// Theo design/AnThu-Home-TuVan.

export const CONSULT_SECTION_ID = 'tu-van';
/** window event: khách đã đăng nhập bấm "Tư vấn ngay" → ChatPopup (bubble) mở khung chat; listener gọi preventDefault() nếu đã xử lý */
export const OPEN_CONSULT_EVENT = 'anthu:open-consult';
export const CONSULT_STORAGE_KEY = 'anthu_home_consult';
/** số điện thoại đã dùng để login guest lần gần nhất — đổi số thì login lại */
export const GUEST_PHONE_KEY = 'anthu_guest_phone';
/** prefix key đánh dấu đã gửi tin giới thiệu (tên + sản phẩm) cho 1 conversation */
export const GUEST_INTRO_KEY_PREFIX = 'anthu_consult_intro:';

export type ConsultInfo = {
  name: string;
  phone: string;
  product: string;
};

export type ConsultStored = ConsultInfo & {
  /** popup đang mở — để mở lại sau khi reload (vd. khi nhân viên nhận tư vấn, chat tự reload) */
  isOpen?: boolean;
  /** đã bấm "Bắt đầu tư vấn" ít nhất 1 lần với bộ thông tin này */
  submitted?: boolean;
};

export const EMPTY_CONSULT: ConsultInfo = { name: '', phone: '', product: '' };

export const loadConsult = (): ConsultStored | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(CONSULT_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    return {
      name: typeof data.name === 'string' ? data.name : '',
      phone: typeof data.phone === 'string' ? data.phone : '',
      product: typeof data.product === 'string' ? data.product : '',
      isOpen: !!data.isOpen,
      submitted: !!data.submitted,
    };
  } catch (_) {
    return null;
  }
};

export const saveConsult = (data: ConsultStored) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(CONSULT_STORAGE_KEY, JSON.stringify(data));
  } catch (_) {
    /* private mode / quota — bỏ qua, form vẫn chạy */
  }
};
